function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import styles from './CopyTextButton.module.scss';
import { ActionIcon, Button, CopyButton, Tooltip } from '@mantine/core';
import Icon, { IconSizes } from './Icon';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
function CopyWrapper(_param) {
    var hoverText = _param.hoverText, value = _param.value, children = _param.children, props = _object_without_properties(_param, [
        "hoverText",
        "value",
        "children"
    ]);
    var intl = useIntl();
    var copyText = hoverText !== null && hoverText !== void 0 ? hoverText : intl.formatMessage({
        id: "4l6vz1",
        defaultMessage: [
            {
                type: 0,
                value: "Copy"
            }
        ]
    });
    return /*#__PURE__*/ _jsx(CopyButton, _object_spread_props(_object_spread({
        value: value
    }, props), {
        children: function(param) {
            var copied = param.copied, copy = param.copy;
            return /*#__PURE__*/ _jsx(Tooltip, {
                label: copied ? intl.formatMessage({
                    id: "p556q3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Copied"
                        }
                    ]
                }) : copyText,
                classNames: {
                    tooltip: classNames(_define_property({}, styles.copied, copied))
                },
                "aria-label": copyText,
                position: "top",
                children: children({
                    copied: copied,
                    copy: copy
                })
            });
        }
    }));
}
export function CopyTextButton(_param) {
    var value = _param.value, _param_hidden = _param.hidden, hidden = _param_hidden === void 0 ? false : _param_hidden, buttonProps = _param.buttonProps, props = _object_without_properties(_param, [
        "value",
        "hidden",
        "buttonProps"
    ]);
    return /*#__PURE__*/ _jsx(CopyWrapper, _object_spread_props(_object_spread({
        value: value
    }, props), {
        children: function(param) {
            var copy = param.copy;
            return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                onClick: copy
            }, buttonProps), {
                children: hidden ? new Array(value.length).fill('•').join('') : value
            }));
        }
    }));
}
export function CopyIconButton(_param) {
    var buttonProps = _param.buttonProps, props = _object_without_properties(_param, [
        "buttonProps"
    ]);
    return /*#__PURE__*/ _jsx(CopyWrapper, _object_spread_props(_object_spread({}, props), {
        children: function(param) {
            var copy = param.copy;
            return /*#__PURE__*/ _jsx(ActionIcon, _object_spread_props(_object_spread({
                onClick: copy
            }, buttonProps), {
                children: /*#__PURE__*/ _jsx(Icon, {
                    size: IconSizes.SM,
                    icon: faCopy
                })
            }));
        }
    }));
}
